// extracted by mini-css-extract-plugin
export default {"waitingRoomSensorSelection":"waiting-room-sensor-selection_waitingRoomSensorSelection__MoNPE","menuButtonContainer":"waiting-room-sensor-selection_menuButtonContainer__qrzWP"};